import React, { useEffect, useState } from 'react';
import {
    Box,
    CircularProgress,
    Container,
    Fade,
    Grid,
    IconButton,
    makeStyles,
    Button,
} from '@material-ui/core';
import Page from '../../../components/Page';
import { useNavigate } from 'react-router-dom';
import { getFlors } from '../../../database/API';
import Title from '../../../components/Title';
import { Add } from '@material-ui/icons';
import FlorAdmin from '../../../components/FlorAdmin';
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
    },
    container: {
        paddingTop: 40,
    },
    '@global': {
        html: {
            width: '100%',
            height: '100%',
        },
    },
}));

const FlorsView = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [flors, setFlors] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const get = async () => {
            const { flors } = await getFlors();
            setFlors(flors);
            setLoading(false);
        };

        get();
    }, [navigate]);

    return (
        <Page className={classes.root} title={'Flors'}>
            <Container maxWidth={false} className={classes.container}>
                <Title
                    title={'Flors'}
                    subtitle={'Administra les flors'}
                    button={
                        <Box>
                            <span style={{ marginLeft: 20 }}>
                                <Tooltip title="Crear flor">
                                    <IconButton
                                        className={classes.addButton}
                                        onClick={() => navigate('nou')}
                                    >
                                        <Add />
                                    </IconButton>
                                </Tooltip>
                            </span>
                        </Box>
                    }
                />
                <Box pt={2} spacing={3}>
                    {!loading ? (
                        <Fade in={!loading}>
                            <Grid container spacing={4}>
                                {flors.map((item) => {
                                    return <FlorAdmin item={item} />;
                                })}
                            </Grid>
                        </Fade>
                    ) : (
                        <CircularProgress />
                    )}
                </Box>
            </Container>
        </Page>
    );
};

export default FlorsView;
